import React from 'react';
import Header from './Header';

const PublicRoute = ({ children, onNavigate, noHeader }) => (
  <>
    {!noHeader && <Header onNavigate={onNavigate} />}
    {children}
  </>
);

export default PublicRoute;